/**
 * This function determines if a feature should be shown in the feature toggle UI.
 */
export const isVisibleOnFeatureToggleUI = ({ isInternalOnly, isInternalUser, showInFeatureToggleUI, }) => {
    // Show the feature in the feature toggle UI if:
    // - The feature is internal only and the user is internal
    if (isInternalOnly === true && !isInternalUser) {
        return false;
    }
    // - The feature is not disabled for the public
    if (showInFeatureToggleUI !== false) {
        return true;
    }
    return false;
};
